import { model as config, remote } from '@/config'
import { createEffect, createEvent, createStore, sample } from 'effector'
import { persist, session, local } from 'effector-storage'
import { noop } from '~/shared/effector'
import { aye } from '~/shared/helpers'

export const init = createEvent()

const $newDomainNotificationFor = config.get(
  remote.tria_newDomainNotificationFor
)

export const hideNotification = createEvent()
export const $showNotification = createStore<boolean | null>(null).on(
  hideNotification,
  () => false
)
const $redirectedFromDomain = createStore<string | null>(null)

const shouldShowNotificationFx = createEffect(
  ({ from, notifications }: { from: string | null; notifications: string }) => {
    const currentDomain = window.location.hostname

    for (let redirect of notifications.split(';')) {
      redirect = redirect.trim()
      if (!redirect || !redirect.includes('->')) continue

      const [oldDomain, newDomain] = redirect
        .split('->')
        .map((item) => item.trim())

      if (newDomain !== currentDomain) continue
      if (from === oldDomain || !oldDomain) return true
    }
  }
)

sample({
  clock: [init, $newDomainNotificationFor],
  source: {
    shouldShow: $showNotification,
    from: $redirectedFromDomain,
    notifications: $newDomainNotificationFor,
  },
  filter: ({ shouldShow, notifications }) =>
    shouldShow == null && aye(notifications),
  target: shouldShowNotificationFx,
})

sample({
  clock: shouldShowNotificationFx.doneData,
  filter: (shouldShow) => shouldShow != null,
  target: $showNotification,
})

// we do not use scopes for now, so, ignore this rule
// eslint-disable-next-line effector/require-pickup-in-persist
persist({
  adapter: session,
  store: $redirectedFromDomain,
  key: 'tria__redirect-from-domain',
  fail: noop,
})

// we do not use scopes for now, so, ignore this rule
// eslint-disable-next-line effector/require-pickup-in-persist
persist({
  adapter: local,
  store: $showNotification,
  key: 'tria__show-new-domain-notification',
  fail: noop,
})
